import React, { useState, useEffect, useRef } from 'react';
import { getApiUrl } from '../apiConfig';

const STORAGE_KEY = 'crops_paddy_data_public';

export default function Wee({ onBackClick }) {
    const [cropsData, setCropsData] = useState(() => {
        const local = localStorage.getItem(STORAGE_KEY);
        try {
            return local ? JSON.parse(local) : [];
        } catch (e) {
            return [];
        }
    });
    const [loading, setLoading] = useState(() => {
        const local = localStorage.getItem(STORAGE_KEY);
        try {
            return (local ? JSON.parse(local) : []).length === 0;
        } catch (e) {
            return true;
        }
    });
    const hasLoadedRef = useRef(false);

    useEffect(() => {
        let timerId;
        let isCancelled = false;
        
        const loadData = async () => {
            try {
                const response = await fetch(getApiUrl(`api_crops.php?category=paddy&t=${Date.now()}`), {
                    headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }
                });
                if (isCancelled) return;
                
                if (response.ok) {
                    const text = await response.text();
                    try {
                        const data = JSON.parse(text);
                        if (Array.isArray(data)) {
                            const sortedData = [...data].sort((a, b) => 
                                String(a.year).localeCompare(String(b.year), undefined, { numeric: true })
                            );
                            
                            // We use a function update for setCropsData to avoid needing cropsData as a dependency
                            setCropsData(currentData => {
                                const newDataStr = JSON.stringify(sortedData);
                                const currentDataStr = JSON.stringify(currentData);
                                
                                if (newDataStr !== currentDataStr) {
                                    console.log('🔄 Paddy data update detected, refreshing UI...');
                                    localStorage.setItem(STORAGE_KEY, newDataStr);
                                    return sortedData;
                                }
                                return currentData;
                            });
                            hasLoadedRef.current = true;
                        }
                    } catch (parseErr) {
                        console.warn('Server response is not JSON:', parseErr);
                    }
                }
            } catch (err) {
                console.warn("Server fetch failed, using local storage", err);
            }
            if (!isCancelled) setLoading(false);
        };

        // Initial load
        loadData();

        // 📱 Refresh when coming back to the tab
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                loadData();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            isCancelled = true;
            clearTimeout(timerId);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    return (
        <main className="page-content crops-page" style={{ padding: '28px 16px', paddingBottom: '180px', maxWidth: 1200, margin: '0 auto', position: 'relative' }}>
            <div style={{ maxWidth: 1000, margin: '0 auto' }}>

                <button
                    className="back-button"
                    onClick={() => onBackClick('crops')}
                    style={{
                        backgroundColor: '#0b6b2f',
                        color: 'white',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        marginBottom: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                    }}

                >
                    ← ආපසු
                </button>
                <h1 style={{ color: '#0b6b2f', fontSize: 28, marginBottom: 12, textAlign: 'justify' }}>වී වගාව</h1>
                <hr className="footer-sep" />


                <div className="table-responsive" style={{
                    background: '#fff',
                    borderRadius: '20px',
                    boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
                    padding: '24px',
                    border: '1px solid #f0f0f0'
                }}>
                    <table className="production-table" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ background: '#f9fafb' }}>
                                <th style={{ padding: '16px', borderBottom: '2px solid #eee', color: '#666' }}>කන්නය</th>
                                <th style={{ padding: '16px', borderBottom: '2px solid #eee', color: '#666' }}>වගා කල වපසරිය (හෙක්)</th>
                                <th style={{ padding: '16px', borderBottom: '2px solid #eee', color: '#666' }}>වී නිෂ්පාදනය (මෙ.ටො)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="3" style={{ padding: '40px', textAlign: 'center', color: '#999', fontStyle: 'italic' }}>දත්ත පූරණය වෙමින් පවතියි...</td>
                                </tr>
                            ) : cropsData.length > 0 ? (
                                cropsData.map((item, idx) => (
                                    <tr key={idx} style={{ transition: 'background 0.2s' }} onMouseOver={(e) => e.currentTarget.style.background = '#fcfcfc'} onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}>
                                        <td style={{ padding: '16px', borderBottom: '1px solid #f0f0f0', fontWeight: '700', color: '#111827' }}>{item.year}</td>
                                        <td style={{ padding: '16px', borderBottom: '1px solid #f0f0f0' }}>{item.area}</td>
                                        <td style={{ padding: '16px', borderBottom: '1px solid #f0f0f0', color: '#059669', fontWeight: '600' }}>{item.production}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" style={{ padding: '40px', textAlign: 'center', color: '#999' }}>තවමත් දත්ත ඇතුළත් කර නොමැත.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>


            </div>

            <style>{`
                @media (max-width: 640px) {
                    .table-responsive {
                        padding: 12px !important;
                        overflow-x: auto;
                    }
                    .production-table th, .production-table td {
                        padding: 12px 8px !important;
                        font-size: 0.85rem;
                    }
                }
            `}</style>
        </main>
    );
}
